define('SuiteCommerce.OrderStatus.Configuration', [], function Configuration() {
	'use strict';
	return {
		environment: null,
		userProfile: null,
		initialize: function initialize(container) {
			this.environment = container.getComponent('Environment');
			this.userProfile = container.getComponent('UserProfile');
		},
		get: function get(name) {
			if (this.environment) {
				return this.environment.getConfig(name);
			}
			return null;
		},
		getSiteSetting: function getSiteSetting(name) {
			if (this.environment) {
				return this.environment.getSiteSetting(name);
			}
			return null;
		},
		getUserProfile: function getUserProfile() {
			if (this.userProfile) {
				return this.userProfile;
			}
			return null;
		},
	};
});
